import axios from "axios";

// Works whether the app is hosted at the domain root or in a subfolder.
// If REACT_APP_BACKEND_URL is set (e.g. Emergent preview), use it; otherwise
// call /api relative to wherever index.html is served from.
const envUrl = process.env.REACT_APP_BACKEND_URL;
const API = envUrl ? `${envUrl}/api` : new URL("api", document.baseURI).href;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("gm_token")) {
      localStorage.removeItem("gm_token");
      if (!window.location.hash.startsWith("#/login")) {
        window.location.hash = "#/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

// Guest photos are saved under the site's own /uploads folder (not under
// /api), so their URL is built from the same origin as the API rather than
// through axios — this works whether the app is hosted at the domain root
// or in a subfolder, same reasoning as the API constant above.
const PHOTO_BASE = envUrl || new URL(".", document.baseURI).href;
export function photoUrl(path) {
  if (!path) return null;
  return `${PHOTO_BASE.replace(/\/$/, "")}/${String(path).replace(/^\//, "")}`;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export default api;
